<div class="map-panel" (mousemove)="onMapMouseMove($event)">
  <div class="map-header">
    <div class="map-legend">
      <label class="legend-checkbox-item" (click)="$event.stopPropagation()">
        <input
          type="checkbox"
          [(ngModel)]="showTypes.drivers"
          (ngModelChange)="onShowTypeChange()"
        />
        <i class="fa fa-circle text-primary"></i> Drivers
      </label>
      <label class="legend-checkbox-item" (click)="$event.stopPropagation()">
        <input
          type="checkbox"
          [(ngModel)]="showTypes.trailers"
          (ngModelChange)="onShowTypeChange()"
        />
        <i class="fa fa-circle text-success"></i> Trailers
      </label>
      <label class="legend-checkbox-item" (click)="$event.stopPropagation()">
        <input
          type="checkbox"
          [(ngModel)]="showTypes.tractors"
          (ngModelChange)="onShowTypeChange()"
        />
        <i class="fa fa-circle text-danger"></i> Tractors
      </label>
      <span class="legend-item"><i class="fa fa-circle text-purple"></i> Selected</span>
      <span class="legend-item" *ngIf="hasAnyRoadCall"
        ><i class="fa fa-circle text-road-call"></i> Road Call</span
      >
      <span class="legend-item" *ngIf="locationMarker"
        ><i class="fa fa-circle text-warning"></i> Filtered Location</span
      >
    </div>
  </div>
  <div class="map-container">
    <google-map
      width="100%"
      height="100%"
      [center]="mapCenter"
      [zoom]="mapZoom"
      [options]="mapOptions"
      (zoomChanged)="onMapZoomChanged()"
    >
      <map-marker *ngIf="locationMarker" [options]="locationMarker"></map-marker>
      <map-circle *ngIf="locationCircle" [options]="locationCircle"></map-circle>
      <map-marker
        *ngFor="let m of allMapMarkers"
        [options]="m.options"
        (mapClick)="onMarkerClick(m)"
        (mapMouseover)="onMarkerMouseOver(m, $event)"
        (mapMouseout)="onMarkerMouseOut()"
      ></map-marker>
    </google-map>
  </div>

  <!-- Map Tooltip -->
  <div
    class="map-tooltip"
    *ngIf="hoveredMarker"
    [style.left.px]="tooltipX"
    [style.top.px]="tooltipY"
  >
    <!-- Cluster -->
    <ng-container *ngIf="hoveredMarker.tooltipData.cardType === 'cluster'">
      <div class="mtt-header mtt-cluster">
        <i class="fa fa-map-marker"></i>
        {{ hoveredMarker.tooltipData.clusterCount }} Units
      </div>
      <div class="mtt-body">
        <div class="mtt-row" *ngIf="hoveredMarker.tooltipData.clusterDrivers?.length">
          <span class="mtt-label"><i class="fa fa-user"></i> Drivers</span>
          <span class="mtt-value">{{ hoveredMarker.tooltipData.clusterDrivers!.join(", ") }}</span>
        </div>
        <div class="mtt-row" *ngIf="hoveredMarker.tooltipData.clusterTractors?.length">
          <span class="mtt-label"><i class="fa fa-truck"></i> Tractors</span>
          <span class="mtt-value">{{ hoveredMarker.tooltipData.clusterTractors!.join(", ") }}</span>
        </div>
        <div class="mtt-row" *ngIf="hoveredMarker.tooltipData.clusterTrailers?.length">
          <span class="mtt-label"><i class="fa fa-list"></i> Trailers</span>
          <span class="mtt-value">{{ hoveredMarker.tooltipData.clusterTrailers!.join(", ") }}</span>
        </div>
      </div>
    </ng-container>

    <!-- Driver -->
    <ng-container *ngIf="hoveredMarker.tooltipData.cardType === 'driver'">
      <div class="mtt-header mtt-driver">
        <i class="fa fa-user"></i>
        {{ hoveredMarker.tooltipData.name }}
        <span class="mtt-driverno">#{{ hoveredMarker.tooltipData.driverNo }}</span>
      </div>
      <div class="mtt-body">
        <div class="mtt-roadcall" *ngIf="hoveredMarker.tooltipData.roadCallStatus">
          <i class="fa fa-exclamation-triangle"></i>
          Road Call: {{ hoveredMarker.tooltipData.roadCallStatus }}
          <span *ngIf="hoveredMarker.tooltipData.roadCallNumber"
            >#{{ hoveredMarker.tooltipData.roadCallNumber }}</span
          >
        </div>
        <div class="mtt-row" *ngIf="hoveredMarker.tooltipData.schedulingTeamName">
          <span class="mtt-label"><i class="fa fa-users"></i> Team</span>
          <span class="mtt-value">
            {{ hoveredMarker.tooltipData.schedulingTeamName }}
            <span *ngIf="hoveredMarker.tooltipData.schedulingTeamBoardName" class="mtt-board"
              >- {{ hoveredMarker.tooltipData.schedulingTeamBoardName }}</span
            >
          </span>
        </div>
        <div class="mtt-row" *ngIf="hoveredMarker.tooltipData.location">
          <span class="mtt-label"><i class="fa fa-map-marker"></i> Location</span>
          <span class="mtt-value">
            {{ hoveredMarker.tooltipData.location }}
            <span class="mtt-age" *ngIf="hoveredMarker.tooltipData.locationAge"
              >({{ hoveredMarker.tooltipData.locationAge }})</span
            >
          </span>
        </div>
        <div class="mtt-row" *ngIf="hoveredMarker.tooltipData.tractorNumber">
          <span class="mtt-label"><i class="fa fa-truck"></i> Tractor</span>
          <span class="mtt-value">{{ hoveredMarker.tooltipData.tractorNumber }}</span>
        </div>
        <div class="mtt-row" *ngIf="hoveredMarker.tooltipData.trailerNumber">
          <span class="mtt-label"><i class="fa fa-list"></i> Trailer</span>
          <span class="mtt-value">{{ hoveredMarker.tooltipData.trailerNumber }}</span>
        </div>
        <div class="mtt-stats">
          <span
            *ngIf="
              hoveredMarker.tooltipData.hoursOfService !== null &&
              hoveredMarker.tooltipData.hoursOfService !== undefined
            "
          >
            <i class="fa fa-clock-o"></i>
            {{ hoveredMarker.tooltipData.hoursOfService | number: "1.1-1" }} HOS
          </span>
          <span>
            <i class="fa fa-road"></i>
            {{ hoveredMarker.tooltipData.milesLast7Days | number }} mi
          </span>
        </div>
        <div class="mtt-quals" *ngIf="hoveredMarker.tooltipData.productQualifications?.length">
          <span
            class="mtt-qual-tag"
            *ngFor="let q of hoveredMarker.tooltipData.productQualifications"
            >{{ q }}</span
          >
        </div>
      </div>
    </ng-container>

    <!-- Tractor -->
    <ng-container *ngIf="hoveredMarker.tooltipData.cardType === 'tractor'">
      <div class="mtt-header mtt-tractor">
        <i class="fa fa-truck"></i> Tractor {{ hoveredMarker.tooltipData.tractorNumber }}
      </div>
      <div class="mtt-body">
        <div class="mtt-roadcall" *ngIf="hoveredMarker.tooltipData.roadCallStatus">
          <i class="fa fa-exclamation-triangle"></i>
          Road Call: {{ hoveredMarker.tooltipData.roadCallStatus }}
          <span *ngIf="hoveredMarker.tooltipData.roadCallNumber"
            >#{{ hoveredMarker.tooltipData.roadCallNumber }}</span
          >
        </div>
        <div class="mtt-row" *ngIf="hoveredMarker.tooltipData.assignedDriverName">
          <span class="mtt-label"><i class="fa fa-user"></i> Driver</span>
          <span class="mtt-value">{{ hoveredMarker.tooltipData.assignedDriverName }}</span>
        </div>
        <div class="mtt-row" *ngIf="hoveredMarker.tooltipData.location">
          <span class="mtt-label"><i class="fa fa-map-marker"></i> Location</span>
          <span class="mtt-value">
            {{ hoveredMarker.tooltipData.location }}
            <span class="mtt-age" *ngIf="hoveredMarker.tooltipData.locationAge"
              >({{ hoveredMarker.tooltipData.locationAge }})</span
            >
          </span>
        </div>
        <div class="mtt-row" *ngIf="hoveredMarker.tooltipData.attachedTrailerNumbers?.length">
          <span class="mtt-label"><i class="fa fa-list"></i> Trailers</span>
          <span class="mtt-value">{{
            hoveredMarker.tooltipData.attachedTrailerNumbers!.join(", ")
          }}</span>
        </div>
        <div class="mtt-row" *ngIf="hoveredMarker.tooltipData.terminal">
          <span class="mtt-label"><i class="fa fa-building"></i> Terminal</span>
          <span class="mtt-value">{{ hoveredMarker.tooltipData.terminal }}</span>
        </div>
        <div
          class="mtt-badge"
          [class.mtt-badge-success]="hoveredMarker.tooltipData.inService"
          [class.mtt-badge-danger]="!hoveredMarker.tooltipData.inService"
        >
          {{ hoveredMarker.tooltipData.inService ? "In Service" : "Out of Service" }}
        </div>
      </div>
    </ng-container>

    <!-- Trailer -->
    <ng-container *ngIf="hoveredMarker.tooltipData.cardType === 'trailer'">
      <div class="mtt-header mtt-trailer">
        <i class="fa fa-list"></i> Trailer {{ hoveredMarker.tooltipData.trailerNumber }}
        <span class="mtt-equip-code" *ngIf="hoveredMarker.tooltipData.equipmentCode">{{
          hoveredMarker.tooltipData.equipmentCode
        }}</span>
      </div>
      <div class="mtt-body">
        <div class="mtt-roadcall" *ngIf="hoveredMarker.tooltipData.roadCallStatus">
          <i class="fa fa-exclamation-triangle"></i>
          Road Call: {{ hoveredMarker.tooltipData.roadCallStatus }}
          <span *ngIf="hoveredMarker.tooltipData.roadCallNumber"
            >#{{ hoveredMarker.tooltipData.roadCallNumber }}</span
          >
        </div>
        <div class="mtt-row" *ngIf="hoveredMarker.tooltipData.assignedDriverName">
          <span class="mtt-label"><i class="fa fa-user"></i> Driver</span>
          <span class="mtt-value">{{ hoveredMarker.tooltipData.assignedDriverName }}</span>
        </div>
        <div class="mtt-row" *ngIf="hoveredMarker.tooltipData.location">
          <span class="mtt-label"><i class="fa fa-map-marker"></i> Location</span>
          <span class="mtt-value">
            {{ hoveredMarker.tooltipData.location }}
            <span class="mtt-age" *ngIf="hoveredMarker.tooltipData.locationAge"
              >({{ hoveredMarker.tooltipData.locationAge }})</span
            >
          </span>
        </div>
        <div class="mtt-row" *ngIf="hoveredMarker.tooltipData.attachedTractorNumber">
          <span class="mtt-label"><i class="fa fa-truck"></i> On Tractor</span>
          <span class="mtt-value">{{ hoveredMarker.tooltipData.attachedTractorNumber }}</span>
        </div>
        <div class="mtt-row" *ngIf="hoveredMarker.tooltipData.terminal">
          <span class="mtt-label"><i class="fa fa-building"></i> Terminal</span>
          <span class="mtt-value">{{ hoveredMarker.tooltipData.terminal }}</span>
        </div>
        <div
          class="mtt-badge"
          [class.mtt-badge-success]="hoveredMarker.tooltipData.inService"
          [class.mtt-badge-danger]="!hoveredMarker.tooltipData.inService"
        >
          {{ hoveredMarker.tooltipData.inService ? "In Service" : "Out of Service" }}
        </div>
      </div>
    </ng-container>
  </div>
</div>
